// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".vge_3{border:4rem solid rgba(48,168,255,.1);border-radius:50%;height:250px;height:25rem;position:relative;width:250px;width:25rem}.vge_3._29Jmk{border-color:rgba(246,86,99,.1)}._3s1il{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;border:1.5rem solid #30a8ff;border-radius:50%;height:225px;height:22.5rem;justify-content:center;left:-27.5px;left:-2.75rem;position:absolute;top:-27.5px;top:-2.75rem;width:225px;width:22.5rem}._29Jmk>._3s1il{border-color:#f65663}._1x2qY{fill:#30a8ff;height:80px;height:8rem;width:80px;width:8rem}._29Jmk ._1x2qY{fill:#f65663}._3KC66{display:-ms-flexbox;display:flex;-ms-flex-align:center;align-items:center;-ms-flex-pack:center;height:251px;height:25.1rem;justify-content:center;width:250px;width:25rem}._2rFom{height:225px;height:22.5rem;width:225px;width:22.5rem}._18Iuq{fill:#30a8ff;height:150px;height:15rem;width:160px;width:16rem}._2iKfy{border:1px solid #e0e8f2;border-radius:5px;margin-top:3rem}._3ti31{border-bottom:1px solid #e0e8f2;padding:1.5rem}.Di91p{padding:1.5rem 1.5rem 0}._32X7H{max-height:310px;max-height:31rem;overflow-y:auto;padding:0 1.5rem 1.5rem}", ""]);
// Exports
exports.locals = {
	"indicatorBackground": "vge_3",
	"error": "_29Jmk",
	"indicator": "_3s1il",
	"indicatorIcon": "_1x2qY",
	"loaderContainer": "_3KC66",
	"loader": "_2rFom",
	"loaderIcon": "_18Iuq",
	"patients": "_2iKfy",
	"patients__head": "_3ti31",
	"patients__searchContainer": "Di91p",
	"patients__listContainer": "_32X7H"
};
module.exports = exports;
